import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import 'firebase/functions';

export const firebaseConfig = {
  apiKey: 'AIzaSyAhrjrY8eAaG6up3FYzMBJMinxTGAjjpQ0',
  authDomain: 'streaming-website-8198f.firebaseapp.com',
  projectId: 'streaming-website-8198f',
  storageBucket: 'streaming-website-8198f.appspot.com',
  messagingSenderId: '228930366638',
  appId: '1:228930366638:web:f880ea5e672e7e6fc5913f',
  measurementId: 'G-1ZGQ1GKYVY',
  //databaseURL: 'streaming-website-8198f.firebaseio.com',
};
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
